import { useState, useContext, useEffect } from "react";
import { useLoaderData } from "react-router-dom";

import DataContext from "../../../context/DataContext";
import { useQueryParams } from "../../../hooks/useQueryParams";
import { ClientDetailContext } from "../../cm/Dashboard/FullPages/ClientDetail/context/ClientDetailContext";
import DocumentUpload from "../../cm/Dashboard/FullPages/ClientDetail/DocumentManager/DocumentUpload";
import DeleteApptv2 from "../../cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/DeleteApptv2";
import EditApptv2 from "../../cm/Dashboard/FullPages/ClientDetail/ProvApptDetails/EditApptv2";
import ModalShell from "../../global/ModalShell";
import ProviderDetail from "../providers/provider-detail";

import AppointmentsTable from "./AppointmentsTable";

export default function Appointments({ caseInfo }) {
  const { appointments, appointmentsCount } = useLoaderData();
  const { filters } = useQueryParams();
  const apptLimit = filters.get("apptLimit");
  const apptSearch = filters.get("apptSearch");
  const [provider, setProvider] = useState(null);
  const [providerDetailDisplay, setProviderDetailDisplay] = useState(false);
  const [selectedAppt, setSelectedAppt] = useState();
  const [openDeleteAppt, setOpenDeleteAppt] = useState(false);
  const [openEditAppt, setOpenEditAppt] = useState(false);
  const { setSelectedAppointment, setIsLaunchedFromAppointmentsTab } =
    useContext(ClientDetailContext);
  const [loading, setLoading] = useState(false);
  const [uploadDocument, setUploadDocument] = useState(false);
  const { activeBills } = useContext(DataContext);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [apptLimit, apptSearch]);

  function handleProviderApptEdit(appt) {
    setSelectedAppt(appt);
    setOpenEditAppt(!openEditAppt);
  }

  const handleUploadDocument = (appt) => {
    setSelectedAppointment(appt);
    setIsLaunchedFromAppointmentsTab(true);
    setUploadDocument(true);
  };

  function handleApptDelete(appt) {
    setSelectedAppt(appt);
    setOpenDeleteAppt(!openDeleteAppt);
  }

  return (
    <>
      <AppointmentsTable
        activeBills={activeBills}
        appointments={appointments}
        appointmentsCount={appointmentsCount}
        caseInfo={caseInfo}
        handleApptDelete={handleApptDelete}
        handleProviderApptEdit={handleProviderApptEdit}
        handleUploadDocument={handleUploadDocument}
        loading={loading}
        setProvider={setProvider}
        setProviderDetailDisplay={setProviderDetailDisplay}
      />
      {providerDetailDisplay && (
        <ProviderDetail
          providerDetail={provider}
          open={providerDetailDisplay}
          setOpen={setProviderDetailDisplay}
        />
      )}
      <EditApptv2
        open={openEditAppt}
        selectedAppt={selectedAppt}
        caseInfo={caseInfo}
        onClose={() => setOpenEditAppt(false)}
      />
      <DocumentUpload
        closeUploadModal={() => setUploadDocument(false)}
        casePk={!caseInfo ? "" : caseInfo?.id}
        clientId={caseInfo?.client?.id}
        uploadDocument={uploadDocument}
        setUploadDocument={setUploadDocument}
        caseInfo={caseInfo}
      />
      <ModalShell
        open={openDeleteAppt}
        setOpen={setOpenDeleteAppt}
        color={"rgb(220 38 38)"}
        title={"Delete Appointment"}
      >
        <DeleteApptv2
          selectedAppt={selectedAppt}
          caseInfo={caseInfo}
          setOpenDeleteAppt={setOpenDeleteAppt}
        />
      </ModalShell>
    </>
  );
}
